import {
 LOADING_ENTRY, EXPENSE_ACCOUNT_LOADING, VENDOR_LOADING
} from '../actions';

const INITIAL_STATE = { loading: false }
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING_ENTRY || EXPENSE_ACCOUNT_LOADING || VENDOR_LOADING:
      return { loading: true };
    default:
      return INITIAL_STATE;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loadingReducer.js